
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/survey",
      function () {
        return require("private-next-pages/survey.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/survey"])
      });
    }
  